import { call, put, fork, takeLatest } from 'redux-saga/effects'
import * as ActionTypes from '../modules/ActionTypes';
import { getSsoCheck } from '../services/ssoCheck';

function* callGetSsoStatus(action) {
    const { response, error} =  yield call(getSsoCheck, action.payload);

    if (response) {
        yield put({type: ActionTypes.GET_SSO_STATUS.SUCCESS, payload: { ...response.data }});
        console.debug("[SUCCESS][getSsoStatus]")
    } else {
        console.error("[ERROR][getSsoStatus]", error)
    }
}

function* watchGet() {
    yield takeLatest(ActionTypes.GET_SSO_STATUS.REQUEST, callGetSsoStatus);
}

export default function* ssoStatusSaga() {
    yield fork(watchGet);
}